<!-- Translated: yes -->
<template>
  <div>
    <div ref="klarnaCode" id="klarna-checkout-container" style="overflow-x: hidden;">
    </div>
  </div>
</template>

<script>
import API from '@/classes/API';

export default {
  props: {
  },
  components: {
  },
  data() {
    return {
      snippet: null,
      loaded: false,
    };
  },
  async mounted() {
    const url = encodeURIComponent(`${window.location.protocol}//${window.location.host}`);
    const src = API.getUrl(`/payments/klarna-checkout?script-only=1&order=${this.$route.query.order}&url=${url}`);
    const s = document.createElement('script');

    this.createCookie('token', 'test', 1);

    s.setAttribute('src', src);
    this.$refs.klarnaCode.appendChild(s);
    this.loaded = true;
  },
  methods: {
    createCookie(name, value, days) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const dateToString = date.toUTCString();
        expires = `; expires=${dateToString}`;
      }
      document.cookie = `${name}=${value}${expires}; path=/`;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
</style>



// WEBPACK FOOTER //
// KlarnaCheckout.vue?4348fd62